export default {
  htmlTit: '艺赛旗 - 控制台',
  authorizationTip: '亲，登录授权时间已到或者您已退出，请重新登录',
  agreement: '您好，请阅读并同意以下协议：',
  agree: '同意',
  disagree: '不同意',
  noResponseData: '页面中有部分接口请求失败，请联系管理员或提交工单；稍后请重新刷新页面',
  goToOAuth: '正在前往登录授权...',
  authorize: '正在授权...',
  logoutTip: '真的要注销登录吗？',
  developing: '正在开发中，敬请期待...',
  applyTips: '您还不是开发者，需要申请吗？',
  devClientAccess: '管理员不可进入开发者',
  noData: '暂无数据',
  read: '我已阅读并同意',
  agreen: '艺赛旗应用市场用户协议',
  isRead: '请先阅读并同意协议',
  // 任务管理
  task: {
    taskManagement: '任务管理',
    procName: '流程名',
    taskStatus: '状态',
    robotRange: '机器人',
    taskDetail: '任务详情',
    publish: '发布',
    version: '版本',
    status: {
      pending: '等待派发',
      pendout: '派发超时',
      running: '正在执行',
      success: '执行成功',
      timeout: '执行超时',
      failing: '失败中的',
      failed: '已经失败',
      stopping: '准备停止',
      stopped: '已停止'
    },
    start: '开始',
    end: '结束',
    stopping: '已准备停止',
    readyToReDo: '已准备重做',
    stopCheckTipMsg: '选中任务中有正在执行的，请检查',
    stopTipMsg: '确认停止任务吗？',
    delCheckTipMsg: '选中任务中有正在执行或者准备停止的，请检查',
    delTipMsg: '确认删除该任务吗？',
    logDownloadMsg: '该任务无可下载日志'
  },
  // 变量管理
  variate: {
    variateManagement: '变量管理',
    variableName: '变量名',
    variableValue: '变量值',
    applicableRobot: '适用机器人',
    clentModified: '客户端可修改',
    mTitleAdd: '新增变量',
    mTitleMod: '修改变量',
    variableInfo: '变量信息',
    variableJurisdiction: '权限',
    delTipMsg: '确认删除该变量吗？'
  },
  // 任务数据
  taskData: {
    taskDataM: '任务数据',
    spaceName: '空间名',
    maxFailedAttempts: '最大失败尝试次数',
    spaceDescription: '空间描述',
    Last24Hours: '过去24小时状况',
    count: '总数',
    success: '成功数',
    fail: '失败数',
    other: '其他',
    add: '新增任务数据',
    modify: '修改任务数据',
    info: '任务数据',
    jurisdiction: '权限',
    delTipMsg: '确认删除该任务数据吗？',
    clearTipMsg: '确认清除记录吗？',
    status: {
      pending: '等待运行',
      waittimeout: '等待超时',
      running: '正在运行',
      success: '运行成功',
      failed: '运行失败',
      deleted: '已删除',
      retry: '重试运行'
    },
    // 查看数据
    view: {
      dataView: '数据查看',
      content: '内容',
      customField: '自定义字段',
      customFieldMsg: '无数据不可操作',
      fieldName: '字段名称',
      choose: '选择',
      reference: '参考值',
      displayName: '显示名称',
      delTipMsg: '确认删除该项数据？',
      restartTipMsg: '确认重做？',
      setDisplayNameTip: '请注意：未选中状态下，不可定义显示名称'
    },
    // 访问记录
    logs: {
      back: '返回',
      isBack: '确认返回？'
    }
  },
  // 机器人与设计器
  robotDes: {
    robotList: '机器人列表',
    agentnumbers: '机器人总数(台)',
    free: '空闲',
    running: '运行',
    offline: '离线',
    unbound: '未绑定',
    abilityValue: '余额',
    recharge: '充值',
    rechargeInfo: ['在线能力剩余点数', '充值方式', '充值金额', '即将充值的点数', '立即充值'],
    rechargeType: ['支付宝充值', '微信充值', '{num} 元', '电汇充值'],
    rechargeTips: ['请选择充值方式', '请选择充值金额', '请先阅读并同意协议'],
    allStatus: '全部状态',
    buyRobot: '购买机器人',
    allowInfo: '许可信息',
    bindUser: '当前绑定的用户',
    runStatus: '运行状态',
    newInfo: '最近信息',
    login: '登录',
    langLimt: '长度限制为0-128个字符',
    nameRequire: '名称必填',
    editName: '编辑实例名称',
    over: '过期',
    options: '执行',
    isFee: '是否确认免费延长30天？',
    isDel: '是否确认删除该机器人？',
    errAndOk: ['正在执行', '执行成功', '失败中', '已经失败', '准备停止', '已停止'],
    reFee: '请先选择需要续费的机器人或设计器',
    apply: '申请延期',
    tabForm: ['邮箱', '公司', '手机号', '申请原因', '申请销售', '申请人姓名'],
    isError: '请输入正确的{type}',
    isRequire: '{type}必填',
    copyTip: '复制编号',
    copyOK: '复制成功',
    copyError: '复制失败，请手动复制'
  },
  // 流程管理
  process: {
    proManage: '流程管理',
    disable: '禁用',
    enable: '启用',
    upload: '上传',
    file: '文件',
    ipkg: '请上传ipkg文件!',
    proName: '流程名',
    runStatus: '运行状态',
    robotRange: '机器人范围',
    schedule: '调度',
    taskTime: '下一个调度时间',
    allRobot: '所有机器人',
    total: '共',
    schDetail: '个调度，点击编辑查看详情',
    robotDetail: '个机器人，点击编辑查看详情',
    saveOrSet: '保存并配置',
    delTip: '是否确认删除该流程？',
    isEnable: '是否 启用 该流程？',
    isDisable: '是否 禁用 该流程？'
  },
  // 流程配置
  proConfig: {
    config: '流程配置',
    process: '流程',
    robot: '机器人',
    version: '版本',
    name: '名称',
    seq: '排序',
    timeMin: '手动执行时间(分钟)',
    timeOut: '超时时间(秒)',
    runModal: '运行模式',
    modal: '模式',
    exprss: '表达式',
    status: '状态',
    time: '时间',
    schTime: '调度时间',
    timing: '定 时',
    minute: '每分钟',
    hour: '每小时',
    day: '每 天',
    week: '每 周',
    month: '每 月',
    define: '自定义',
    startTime: '开始时间',
    interval: '每隔',
    minu: '分钟',
    once: '发生一次',
    eTime: '执行时间',
    score: '分',
    tHour: '小时',
    tWeek: '周',
    selMon: '选择月',
    selDay: '选择天',
    expr: '表达式',
    senSet: '高级设置',
    efficeTime: '有效日期',
    waitTime: '等待超时时间',
    weekRun: '工作日运行',
    failTimes: '失败重试次数',
    waitTimeArr: ['30秒', '1分钟', '30分钟', '1小时', '8小时', '1天'],
    lastMonth: '每月最后一天',
    disDel: '活跃的版本不能删除',
    selRobot: '请选择机器人',
    weekArr: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
    modeArr: ['定时', '启动', '常驻'],
    isBack: '如返回，您所修改内容会丢失，确认返回吗？',
    errDate: '请选择有效日期',
    errStart: '请选择开始时间',
    errMin: '每隔XXX必填，且是数字',
    errTime: '执行时间必填',
    errWeek: '请选择一个周',
    errMonth: '请选择月份',
    errDay: '请选择天',
    errExpre: '表达式必填',
    errName: '流程名必填',
    tempStart: '临时任务启动成功',
    monArr: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    global: '模式',
    globalType: ['每日执行', '工作日执行', '非工作日执行'],
    set: '例外时间',
    tipScript: ['执行', '不执行']
  },
  // 访问记录
  varRecord: {
    viewRecord: '访问记录',
    colTable: ['动作', '机器人', '流程', '任务编号', '时间'],
    isClear: '是否确认清空记录？'
  },
  // 我的账户
  myAccount: {
    menu: ['基本设置', '安全设置', '账户绑定', '推荐有礼'],
    submit: '提交',
    formItem: ['行业', '昵称', '公司名称', '国家/地区', '地址', '联系电话'],
    upHead: '上传头像',
    tipPhone: '请输入正确的手机号',
    tipUpload: '上传的图片不能超过2M',
    curAccount: '您当前的账号安全程度',
    securityLevel: '安全级别',
    levelList: ['低', '中', '高'],
    continue: '继续努力',
    securType: ['登录密码', '手机绑定', '邮箱绑定'],
    tipPwd: '安全性高的密码可以使账号更安全。建议您定期更换密码，设置一个包含字母，符号或数字中至少两项且长度超过7位的密码。',
    securState: ['已设置', '修改', '已绑定', '解绑', '未绑定', '绑定'],
    bindPhone: '您已绑定了手机',
    phone: '您的手机为安全手机，可以找回密码',
    bindEmail: '您已绑定了邮箱',
    accountList: ['微信账户', '钉钉账户'],
    isBind: '是否确认解绑？',
    NickName: '昵称不能包含艺赛旗',
    gift: ['推荐好友赢取海量Y币', '每推荐一位好友注册艺赛旗生态ID，您都将获得', 'Y币的奖励（可用于在', '中兑换礼品及产品周边）', '您当前已推荐了', '位完成艺赛旗ID的注册！', '扫一扫 完成推荐注册', '复制二维码', '复制注册链接', '一旦发现恶意行为，将追究法律责任。最终解释权归艺赛旗所有'],
    yMall: 'Y币商城'
  },
  // 业务日志
  bLog: {
    title: '业务日志',
    delTip: '是否确认删除业务日志？',
    delViewCon: '请先选择需要删除的视图',
    delViewTip: '是否确认删除选中的视图',
    conOne: '表格显示必须保留一个字段',
    errView: '请输入视图名称',
    requireOne: '必须要添加一个自定义字段',
    isChoose: '您还没有添加视图,请先去添加',
    defView: '默认',
    viewM: '视图管理',
    viewN: '视图名称',
    viewT: '时间',
    viewText: '视图',
    errTip: '请先选择需要删除的数据'
  },
  // 投资报表
  roi: {
    title: '投资回报',
    monArr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    panelTitle: ['机器人数', '机器人运行时长（分钟）', '任务日志'],
    invest: 'RPA-综合分析-投资回报分析',
    lineArr: ['节约时间%', '预估人工用时分钟', '机器人用时分钟'],
    logTab: ['时间', '机器人', '流程', '执行时长(min)', '对比人工时长', '任务状态', '异常', '描述', '执行结果', '等待时长(min)']
  },
  // 报表中心
  report: {
    title: 'RPA综合报表 - {title}',
    process: {
      count: 'RPA-KPI-最近执行过的流程数',
      task: 'RPA-分布-流程任务',
      error: 'RPA-分布-流程错误分布',
      taskTrend: 'RPA-趋势堆叠-流程任务趋势',
      timeTrend: 'RPA-趋势堆叠-流程时间（分钟）',
      log: 'RPA任务日志'
    },
    robot: {
      count: 'RPA-KPI-机器人数',
      runTime: 'RPA-KPI-机器人运行时长（分钟）',
      task: 'RPA-分布-机器人任务',
      error: 'RPA-分布-机器人错误分布',
      taskTrend: 'RPA-趋势堆叠-机器人任务趋势',
      timeTrend: 'RPA-趋势堆叠-机器人工作时间（分钟）',
      log: 'RPA任务日志'
    },
    task: {
      count: '任务数',
      duration: '任务平均时长（分钟）',
      fails: '失败任务',
      error: '任务错误原因',
      taskTrend: '任务趋势',
      timeTrend: '机器人运行时长（分钟）',
      log: '任务日志',
      errLog: '错误日志',
      failed: '失败'
    }
  },
  // 新手包
  novice: {
    renew: '您的设计器/机器人即将到期，现在可通过购买 ',
    ext: '进行延期！',
    tip: '提示：一个ID只能购买一次，详见活动规则>',
    closeTip: '不再提示',
    buy: '立即购买',
    titleH31: '新手大礼包',
    erTip: '您已购买过，一个人只能购买一次，不可重复购买',
    cancenTip: '您有待支付的订单，请先取消才能再次购买',
    pay: '微信支付 | 支付宝支付 | PayPal支付',
    open: '打开手机微信 | 打开手机支付宝 | 打开 PayPal 网站',
    sace: '扫一扫继续付款 | 点击链接继续付款',
    popUps: ['请确认您购买的礼包', '低至', '元', '原价', '点击选择支付方式']
  },
  // 我的卡包
  card: {
    title: '我的卡包',
    status: ['全部状态', '未使用', '已使用', '已过期', '已作废'],
    card: '兑换卡',
    tdThed: ['有效期', '产品', '卡号', '购买时间', '订单号'],
    time: '{s}s后，',
    again: '重新提取密码',
    msg: '密码已重新提取到 {pwd} ,请注意查收',
    tip: '短时间内不可重复获取，请稍后再试'
  },
  // 电汇支付
  wire: {
    title: '电汇支付'
  },
  // other
  'app.exception.description.403': '抱歉，你无权访问此页面',
  'app.exception.description.404': '抱歉，你访问的页面不存在',
  'app.exception.description.500': '抱歉，服务器出错了',
  'component.globalHeader.footer.links': '中国RPA行业领航者 - 沪ICP备12049238号',
  'component.globalHeader.footer.copyright': '艺赛旗软件',
  'app.switchlang.success': '语言切换成功!'
}
